var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tabs"},_vm._l((_vm.tabs),function(tab){return _c('li',{key:tab.id,class:{active: tab.id === _vm.value},on:{"click":function($event){return _vm.input(tab.id)}}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }